import classNames from 'classnames';
import React from 'react';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  position?: 'top' | 'bottom';
};
const CarouselTitle: React.FC<Props> = ({ position = 'top' }) => {
  return (
    <div className={classNames(styles.carouselTitle, { [styles.carouselTitleBottom]: position === 'bottom' })}>
      {intlGet('Section.Carousel.Title', 'Carousel')}
    </div>
  );
};

export default CarouselTitle;
